import { Box, Divider, Stack, Typography } from '@mui/material'
import React from 'react'
import { ReactFitty } from 'react-fitty'
import Grid from '@mui/material/Grid2';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import photo from '../../assets/img/aboutPage/photo.jpg'
import styles from './About.module.scss'

const About = () => {
  return (
    <Grid container spacing={2} height={"100dvh"}>
      <Grid size={{ xs: 12, md: 6, lg: 6 }}>
        <Box sx={{
          padding: '100px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: '100%',
          zIndex: 2,
          position: 'relative',
          '@media screen and (max-width: 600px)': {
            padding: '20px 10px'
          },
          '@media screen and (min-width: 601px) and (max-width: 900px)': {
            padding: '20px 10px'
          },
          '@media screen and (min-width: 901px) and (max-width: 1200px)': {
            padding: '20px 10px'
          }
        }}>
          <Box>
            <Typography
              color='secondary'
              sx={{
                fontFamily: "Great Vibes",
                textAlign: 'left',
                position: 'relative',
                zIndex: 2,
                width: '100%',
                // marginTop: "-150px",
                fontSize: '4rem',
                padding: '0 30px',
                color: '#fd4002'
              }}>
              Hello, I'm
            </Typography>
            <Typography
              color='primary'
              sx={{ textAlign: 'center', position: 'relative', zIndex: 1, lineHeight: 0.7, marginTop: "-45px", }}
              component={ReactFitty}
            >
              RUSLAN
            </Typography>
            <Divider sx={{ margin: '20px 0' }} />
            <Typography
              color='primary'
              sx={{ textAlign: 'center', position: 'relative', zIndex: 1, lineHeight: 0.8 }}
              component={ReactFitty}
            >
              FRONTEND
            </Typography>
            <Typography
              color='primary'
              sx={{ textAlign: 'center', position: 'relative', zIndex: 1, lineHeight: 0.8 }}
              component={ReactFitty}
            >
              DEVELOPER
            </Typography>
          </Box>
          <Box>
            <Stack flexDirection={"row"} gap={"10px"} alignItems={"center"}>
              <Typography fontSize={"2rem"} color='primary'>Обо мне</Typography>
              <DoubleArrowIcon sx={{ color: '#fd4002', fontSize: '3rem' }} />
            </Stack>
            <Typography
              color='primary'
              gutterBottom
              sx={{
                '@media screen and (max-width: 600px)': {
                  fontSize: '0.8rem'
                },
                // '@media screen and (min-width: 901px)': {
                //   fontSize: '2rem'
                // }
              }}>
              Я разработчик React & TypeScript, создающий масштабируемые, эффективные и интуитивные веб-приложения. Моя цель — писать чистый код, продуманный UI/UX и оптимизированные решения, которые обеспечивают лучший пользовательский опыт.
            </Typography>
            <Typography
              color='primary'
              gutterBottom
              sx={{
                '@media screen and (max-width: 600px)': {
                  fontSize: '0.8rem'
                },
                // '@media screen and (min-width: 901px)': {
                //   fontSize: '2rem'
                // }
              }}>
              Меня вдохновляет решение сложных задач и превращение идей в элегантные цифровые продукты. Будь то создание стильного интерфейса или оптимизация производительности — я всегда стремлюсь к надежности и инновациям.
            </Typography>
            <Typography
              color='primary'
              gutterBottom
              sx={{
                '@media screen and (max-width: 600px)': {
                  fontSize: '0.8rem'
                },
                // '@media screen and (min-width: 901px)': {
                //   fontSize: '2rem'
                // }
              }}>
              Давай создадим что-то крутое вместе! 🚀
            </Typography>
          </Box>
        </Box>
      </Grid>
      <Grid size={{ xs: 12, md: 6, lg: 6 }}>
        <Box sx={{
          padding: '0 0 0 100px',
          width: '100%',
          '@media screen and (max-width: 600px)': {
            padding: '0',
          },
          '@media screen and (min-width: 601px) and (max-width: 900px)': {
            padding: '0 0 0 50px',
          },
          '@media screen and (min-width: 901px) and (max-width: 1200px)': {
            padding: '0 0 0 50px',
          }
        }}>
          <img src={photo} alt="my-photo" className={styles.myPhoto} style={{ width: '100%', height: '100dvh', objectFit: 'contain' }} />
        </Box>
      </Grid>
    </Grid>
  )
}

export default About